import GrowthHubElement from './controllers/growth-hub';

/**
 * How long to keep the FOUC guard style before force-removing it. The guard
 * hides the host's slotted content until `<growth-hub>` is defined; if the
 * element never upgrades (script-load race/failure), this fallback ensures the
 * host content is still revealed instead of staying permanently blank.
 */
export const FOUC_FALLBACK_TIMEOUT_MS = 5000;

export default (function () {
  const generateXplGrowthHub = () => {
    let isActive = false;
    let currentUser = {
      currentAccount: {
        id: null as unknown as number,
        name: '',
        metadata: {},
        vendor: null,
        externalId: null,
      },
      email: '',
      fullName: '',
      isSuper: false,
      userHash: '',
      uuid: '',
    };

    return {
      get currentUser() {
        return currentUser;
      },
      set currentUser(updatedCurrentUser) {
        currentUser = updatedCurrentUser;
      },
      get isActive() {
        return isActive;
      },
      setIsActive() {
        isActive = true;
        return isActive;
      },
      init() {
        const styleElementId = 'data-growth-hub-client-css';
        const growthHubElmName = 'growth-hub';

        let styleElement = document.querySelector(`[${styleElementId}]`);
        if (!styleElement) {
          styleElement = document.createElement('style');
          styleElement.setAttribute(styleElementId, 'true');
          styleElement.textContent = `growth-hub:not(:defined) > * { display: none; }`;
          document.head.appendChild(styleElement);
        }

        const removeFoucGuard = () => {
          styleElement?.parentNode?.removeChild(styleElement);
        };

        if (!customElements.get(growthHubElmName)) {
          customElements.define(growthHubElmName, GrowthHubElement);
        }

        // Reveal the host content as soon as the element is defined. The guard
        // is only needed while `:not(:defined)` matches, so removing it here is
        // safe cleanup once the element has upgraded.
        customElements
          .whenDefined(growthHubElmName)
          .then(removeFoucGuard)
          .catch(() => {
            /* whenDefined only rejects on an invalid name; ignore. */
          });

        // Fail-safe: if the element never upgrades, force-remove the guard so
        // the host app is never left permanently hidden behind a blank screen.
        setTimeout(removeFoucGuard, FOUC_FALLBACK_TIMEOUT_MS);
      },
    };
  };

  window.XplGrowthHub = generateXplGrowthHub();
})();
